import React, { useState, Component } from 'react';
import cn from 'classnames';
import { Modal, Form, Button, Input, Avatar, Spin, Empty } from 'antd';
import { sagaModal } from 'redux-saga-modal';
import debounce from 'lodash/debounce';
import styles from './style.module.less';
import * as apis from '@/apis';
import { fetchList as fetchStaffList } from '@/models/employee/services';

const isTenantMode = process.env.APP_MODE === 'tenant';

@Form.create()
class AssignOrderForm extends Component {
  state = {
    loading: false,
    selected: null,
    list: [],
  };

  componentDidMount() {
    this.fetchList();
  }

  fetchList = debounce(async () => {
    this.setState({
      loading: true,
    });
    let users = [];
    if (isTenantMode) {
      const { data: result } = await fetchStaffList(this.props.tenantId);
      users = result.map((item) => item.user);
    } else {
      const { data: result } = await apis.findManager();
      users = result.map((item) => item.user);
    }

    this.setState({
      loading: false,
      list: this.props.filterFunc ? users.filter(this.props.filterFunc) : users,
      selected: null,
    });
  }, 300);

  handleSelect = (id) => () => {
    this.setState({
      selected: this.state.selected === id ? null : id,
    });
  };

  handleSave = () => {
    if (this.state.selected) {
      this.props.submit({ selected: this.state.selected });
    }
  };

  render() {
    const { getFieldDecorator, validateFields } = this.props.form;
    const { loading, list, selected } = this.state;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      layout: 'vertical',
    };

    return (
      <Form {...formItemLayout} className={styles.form}>
        <Form.Item wrapperCol={{ span: 24 }}>
          <Spin spinning={loading}>
            <div className={styles.userWrap}>
              <div className={styles.userList}>
                {list.map((user) => (
                  <div
                    className={cn(
                      styles.user,
                      user._id === selected && styles.selected
                    )}
                    onClick={this.handleSelect(user._id)}
                    key={user._id}
                  >
                    <Avatar
                      className={styles.avatar}
                      src={user.avatar}
                    ></Avatar>
                    <div className={styles.uname}>{user.name}</div>
                  </div>
                ))}
              </div>
            </div>
          </Spin>
        </Form.Item>
        <Form.Item wrapperCol={{ span: 24 }} className={styles.footer}>
          <Button
            type="primary"
            onClick={this.handleSave}
            disabled={loading || !selected}
          >
            指派
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

function AssignOrderDialog({
  modal: { name },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={360}
      style={{ top: '30vh' }}
      visible={isOpen}
      onCancel={hide}
    >
      <AssignOrderForm {...ownProps} submit={submit} />
    </Modal>
  );
}

export default sagaModal({
  name: 'ORDER_ASSIGN_DIALOG',
})(AssignOrderDialog);
